export default {
  lineNumberColor: `#eaeaea`,
  lineNumberBgColor: `#000`,
  backgroundColor: `#000`,
  textColor: `#eaeaea`,
  substringColor: `#eaeaea`,
  keywordColor: `#fff000`,
  attributeColor: `#ff00ff`,
  selectorAttributeColor: `#000fff`,
  docTagColor: `#eaeaea`,
  nameColor: `#ff0000`,
  builtInColor: `#ff00ff`,
  literalColor: `#ff0000`,
  bulletColor: `#00ff00`,
  codeColor: `#eaeaea`,
  additionColor: `#eaeaea`,
  regexpColor: `#ff00ff`,
  symbolColor: `#fff000`,
  variableColor: `#00ffff`,
  templateVariableColor: `#00ffff`,
  linkColor: `#ff00ff`,
  selectorClassColor: `#fff000`,
  typeColor: `#eaeaea`,
  stringColor: `#00ff00`,
  selectorIdColor: `#00ffff`,
  quoteColor: `#00ffff`,
  templateTagColor: `#eaeaea`,
  deletionColor: `#eaeaea`,
  titleColor: `#00ffff`,
  sectionColor: `#000fff`,
  commentColor: `#969896`,
  metaKeywordColor: `#eaeaea`,
  metaColor: `#fff`,
  functionColor: `#eaeaea`,
  numberColor: `#ff0000`,
}
